import React, { useContext } from "react";
import { AppProvider } from "../../maps/context/context";
import {
  LicenseTypes,
  PageFor,
  empType,
} from "../../../../../utils/Enum.types";
import Navbar from "../../../../common/layout/Navbar";
import List, { VendorListPageFor } from "./List";
import { Title } from "../../../../../stories/Title/Title";
import Table, { ItemDetailsTableFor } from "../assetwise/Table";
import ArrowRight from "../../../../../images/ArrowRight.svg";
import { useNavigate } from "react-router-dom";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../context/context";

const VendorWiseItemDetails = () => {
  const navigate = useNavigate();
  const { customer_id, company_id } = useUrlParams();
  const { state } = useContext(AppContext);

  const showNavbar =
    state.empSubType === empType.JCP ||
    state.empSubType === empType.PMU ||
    state.empSubType === empType.VENDOR_MANAGER ||
    state.empSubType === empType.HELP_DESK;

  return (
    <AppProvider>
      <Navbar
        NavType={showNavbar ? LicenseTypes.DASHBOARD : LicenseTypes.COMPANY}
      />
      <div className="asset-reports">
        <div className="asset-reports__left">
          <List pageType={VendorListPageFor.VENDOR_WISE} />
        </div>
        <div className="asset-reports__right">
          <Table
            pageType={ItemDetailsTableFor.VENDOR_WISE}
            type={PageFor.GENERAL}
          />
        </div>
      </div>
    </AppProvider>
  );
};

export default VendorWiseItemDetails;
